<template>
  <section
    class="component-bd673c97"
    resmed-component-name="explore_card_3col_icon-line_graphic_text_link"
    v-bind:style="{ background: acf.layout['background'] }"
  >
    <div class="component" v-bind:class="[`s-${$root.site}`]">
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-5 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2>{{ acf.headline }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="items">
              <div class="item" v-for="(item, index) in acf.items">
                <div
                  class="card"
                  v-bind:class="{
                    'has-bg-dots': acf.layout['has-bg-dots'],
                  }"
                >
                  <div class="mb-3 content">
                    <figure v-if="item.icon">
                      <img
                        class="img-fluid"
                        v-bind:src="`${item.icon}`"
                        alt=""
                      />
                    </figure>

                    <h4 v-html="item.title"></h4>
                    <p v-if="item.description" v-html="item.description"></p>
                  </div>

                  <div class="call-to-action">
                    <a
                      v-bind:href="item.cta.href"
                      v-bind:target="item.cta.target[0]"
                      class="btn cta-pill hallow-white icon right-arrow"
                      >{{ item.cta.text }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-bd673c97", // explore_card_3col_icon-line_graphic_text_link
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-bd673c97 {
  // -->
}

.component {
  padding: 5rem 0 4rem 0;

  h2 {
    position: relative;
    @extend %eyebrow-center;
  }

  .items {
    margin: 0 -0.625rem;
    display: flex;
    flex-direction: column;
    justify-content: center;

    @media (min-width: 768px) {
      flex-direction: row;
      flex-wrap: nowrap;
      height: 100%;
    }

    .item {
      padding: 0.625rem;
      display: flex;
      align-items: stretch;
      flex-grow: 1;
      width: 100%;
      flex-direction: column;

      @media (max-width: 767px) {
        min-height: 280px;
        margin: 0 auto;
      }

      h4 {
        position: relative;
        margin-bottom: 0.825rem;
      }

      .card {
        display: flex;
        flex-direction: column;
        color: inherit;

        position: relative;
        background-size: cover;
        background-position: center center;

        box-shadow: 0 2rem 3rem 0 rgba(0, 0, 0, 0.125);
        border-radius: 6px;

        margin: 0 auto;
        padding: 3rem 2rem 6rem 2rem;

        max-width: 360px;
        transition: all 0.5s;

        width: 100%;
        height: 100%;
        min-height: 300px;

        @media (min-width: 768px) {
          max-width: none;
          min-height: 260px;
        }

        @media (min-width: 1200px) {
          min-height: 260px;
          padding: 3rem 3rem 6rem 3rem;
        }

        .content {
          text-align: center;
        }

        * {
          color: $cc-resmed-white;
        }

        .btn {
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          bottom: 2rem;
        }
      }

      figure {
        max-width: 8rem;
        margin: 0 auto 3rem auto;

        img {
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}

.component {
  // default
  .card {
    background-color: $cc-resmed-pulse-blue;

    &.has-bg-dots {
      background-image: url(#{$assets}/images/background-blue-dots.svg);
    }
  }

  &.s-sleepapnea,
  &.s-sleep-apnea {
    .card {
      background-color: $cc-resmed-sa-purple;

      &:hover {
        background-color: #562a7c;
      }

      &.has-bg-dots {
        background-image: url(#{$assets}/images/background-purple-dots.svg);
      }
    }
  }

  &.s-portableoxygen,
  &.s-portable-oxygen {
    .card {
      background-color: $cc-resmed-pulse-blue;

      &.has-bg-dots {
        background-image: url(#{$assets}/images/background-blue-dots.svg);
      }
    }
  }

  &.s-ventilation {
    .card {
      background-color: $cc-resmed-pulse-red;

      &.has-bg-dots {
        background-image: url(#{$assets}/images/background-red-dots.svg);
      }
    }
  }
}
</style>